<!--
 * @Description:插入教学内容
 * @Author: Xyyyyyy
 * @Date: 2023-10-10 10:30:14
 * @LastEditors: Xyyyyyy
 * @LastEditTime: 2023-10-13 14:35:21
-->
<template>
  <div class="tan-chuang">
    <el-dialog class="w500 h450" :model-value="openEdit" :close-on-click-modal="false" :show-close="false" destroy-on-close>
      <template #header>
        <div class="header-left">
          <el-icon class="header-icon">
            <Edit />
          </el-icon>
          <span class="header-title">插入教学内容</span>
        </div>
        <div class="header-right">
          <el-button type="info" text @click="closeWindow('openEdit', emits, false)">
            <el-icon>
              <Close />
            </el-icon>
          </el-button>
        </div>
      </template>
      <el-form ref="ruleFormRef" :model="ruleForm" label-width="140px">
        <el-row>
          <el-col :span="24">
            <el-form-item label="教学内容" prop="id" :rules="[{ required: true, message: '必填项', trigger: 'blur' }]">
              <el-select v-model="ruleForm.id" clearable filterable placeholder="教学内容">
                <el-option v-for="(item,index) in jxnrData" :key="index" :label="item.jxnrbt" :value="item.id" />
              </el-select>
            </el-form-item>
          </el-col>
          <el-col :span="24" v-if="ruleForm.id===null">
            <el-form-item label="教学内容" prop="qtjxnr" :rules="[{ required: true, message: '必填项', trigger: 'blur' }]">
              <el-input type="textarea" v-model="ruleForm.qtjxnr" />
            </el-form-item>
          </el-col>
        </el-row>
      </el-form>
      <template #footer>
        <div class="dialog-footer">
          <div></div>
          <div class="footer_but">
            <el-button type="primary" @click="submit()">保存</el-button>
            <el-button type="info" @click="closeWindow('openEdit', emits, false)">关闭</el-button>
          </div>
        </div>
      </template>
    </el-dialog>
  </div>
</template>
<script setup>
import { defineProps, defineEmits, ref, watch, unref } from 'vue'
import {
  closeWindow,
  loadSelect
} from '@/api/common.js'
const props = defineProps({
  openEdit: { type: Boolean, required: true },
  row: { required: false }
})
const emits = defineEmits(['update:openEdit', 'ReturnData'])
const ruleFormRef = ref(null)
const ruleForm = ref({})
const jxnrData = ref()
const jxnrbt = ref() // 教学内容标题
const jxnrid = ref() // 教学内容id
const row = ref()
// 保存
const submit = async () => {
  if (ruleForm.value.id !== null) {
    const form = unref(ruleFormRef)
    if (!form) return
    await form.validate()
    jxnrData.value.forEach((element) => {
      if (ruleForm.value.id === element.id) {
        jxnrbt.value = element.jxnrbt
        jxnrid.value = element.id
      }
    })
  } else {
    jxnrData.value.forEach((element) => {
      jxnrbt.value = element.jxnrbt
    })
  }
  ruleForm.value.jxnrbt = jxnrbt.value
  emits('ReturnData', ruleForm.value, jxnrbt.value)
  handleClose()
}

const handleClose = () => {
  emits('update:openEdit', false)
}
watch(
  () => props.openEdit,
  () => {
    if (props.openEdit) {
      row.value = props.row

      loadSelect({
        url: '/api/v2/jiaowu/jiaoshixueqijiaoxuejihua/kechengjiaoxuedanyuan',
        parms: {
          kcid: props.row.kcid,
          bjid: props.row.bjid,
          dbgzid: props.row.xqid
        },
        data: jxnrData
      })
    }
  },
  { deep: true, immediate: true }
)
</script>
